module.exports = __webpack_public_path__ + "img/req-btn-ja.0e326ddc.png";